import React from 'react';
import { Route, Switch } from 'react-router-dom';
import Page404 from '../../components/Page404';
import PayTest from './PayTest';

const SystemConfigRouter = (props) => {
  return (
    <Switch>
      <Route exact path={`${props.match.url}/PayTest`} component={PayTest} />
      <Route component={Page404} />
    </Switch>
  );
};

export default SystemConfigRouter;
